export interface PatientAssessmentCardTranslations {
  lastCompleted: string;
  ctas: {
    view: string;
    start: string;
    notImplemented: string;
  },
}

export const patientAssessmentCardTranslationKeys: PatientAssessmentCardTranslations = {
  lastCompleted: 'lastCompleted',
  ctas: {
    view: 'ctas.view',
    start: 'ctas.start',
    notImplemented: 'ctas.notImplemented',
  },
};

export const patientAssessmentCardTranslationsEN: PatientAssessmentCardTranslations = {
  lastCompleted: 'Last completed:',
  ctas: {
    view: 'View',
    start: 'Start',
    notImplemented: 'Not Implemented',
  },
};

export const patientAssessmentCardTranslationsES: PatientAssessmentCardTranslations = {
  lastCompleted: 'Última completada:',
  ctas: {
    view: 'Ver',
    start: 'Comenzar',
    notImplemented: 'No implementado',
  },
};
